import axios, { AxiosInstance, AxiosError } from 'axios';
import { API_BASE_URL } from '../config/api';

// Create axios instance with default config
const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important for cookies
});

// Auth is carried entirely by the httpOnly `token` cookie (sent automatically
// because of `withCredentials`). No Authorization header / localStorage token.

// Event name broadcast when the server rejects us as unauthenticated, so React
// state (AuthContext) can reset the current user. Exported so listeners import
// the same constant rather than a magic string.
export const AUTH_UNAUTHORIZED_EVENT = 'auth:unauthorized';

// Response interceptor: on 401, signal the app to drop any stale user state.
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      window.dispatchEvent(new Event(AUTH_UNAUTHORIZED_EVENT));
    }
    return Promise.reject(error);
  }
);

export default apiClient;

// Helper function to extract error message
export const getErrorMessage = (error: any): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    // Check for validation errors array
    if (data?.errors && Array.isArray(data.errors) && data.errors.length > 0) {
      return data.errors.map((e: any) => e.message).join(', ');
    }
    return data?.message || error.message || 'An error occurred';
  }
  return 'An unexpected error occurred';
};
